import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { useSelector } from "react-redux";
import cn from "classnames";
import styles from "./PastDeals.module.sass";
import API, { axiosInstance } from "../../../utils/API";
import Slider from "react-slick";
import Icon from "../../../components/Icon";
import PastDealsAssetCard from "./PastDealsAssetCard";
import AssetCard from './../../../components/AssetCard/index.js';

const SlickArrow = ({ currentSlide, slideCount, children, ...props }) => (
    <button {...props}>{children}</button>
);

const dateOptions = ["Today", "Morning", "Dinner", "Evening"];
const directionOptions = ["Sellers", "Buyers"];

const PastDealsCustomized = (props) => {
    console.debug('PastDealsCustomized(props)', props);

    const navigate = useNavigate();
    //const exchangeRate = useSelector(state  => state.counter.euroValue);
    const [data, setData] = useState([]);
    //const [date, setDate] = useState(dateOptions[0]);
    //const [direction, setDirection] = useState(directionOptions[0]);
    //const euroValue = useSelector((state) => state.counter.euroValue) || 0;
    let categoryName; // a reusable variable for JSX insertion in multiple places

    useEffect(() => {

        getCategoryList();

        //let urlPath = '/asset/all?saleType=past-deal&status=25&limit=25';
        let urlPath = '/asset/all?status=past-deal&saleType=past-deal&limit=20';
        //let urlPath = '/asset/all?status=past-deal&limit=25';

        let params = {
          // limit: 6,
          // page: 1,
        };

        API.get(
            urlPath
            , {
                params
            }
        ).then((res) => {
            console.debug('PastDealsCustomized: res = ', res);

            if (res.data?.result.assets.rows) {
                let data = res.data?.result.assets.rows;
                setData(data);
            }
        })
    }, [])

    const sliderSettings = {

        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        // adaptiveHeight: true,
        nextArrow: (
          <SlickArrow>
            {/*
            <Icon name="arrownext" viewbox="0 0 13 22" size="13" fill="#FFFFFF" />
            */}
            <Icon name="arrownext" viewbox="0 0 13 22" size="20" fill="#000" />
          </SlickArrow>
        ),
        prevArrow: (
          <SlickArrow>
            <Icon name="arrowprev" viewbox="0 0 13 22" size="20" fill="#000" />
          </SlickArrow>
        ),

        responsive: [
          {
            breakpoint: 1280,
            settings: {
              slidesToShow: 2,
              infinite: true,
            },
          },
          {
            breakpoint: 699
            , settings: {
              slidesToShow: 1
              , infinite: true
            }
          }
        ]
    };

    /*
    const limitTextToCount = (text, count) => {
        return text.slice(0, count) + (text.length > count ? "..." : "");
    };
    */

    const checkForUpcomingBid = (bidStartDate) => {
        let time = new Date(bidStartDate);
        var now = new Date();
        return time < now ? false : true;
    }

    const [categoryFilterObj, setCategoryFilterObj] = useState(null);
    const [categoryList, setCategoryList] = useState([]);

    const getCategoryList = async () => {
        console.log('getCategoryList()');
        await axiosInstance.get('/asset/categories?page=1&limit=100')
            .then(result => {
                console.log(result?.data?.result?.categories);
                console.log(result?.data?.result?.categories.rows);
                setCategoryFilterObj(result?.data?.result?.categories?.rows);
                let categories = result?.data?.result?.categories?.rows?.map(
                    category => category.name
                );
                setCategoryList(['All', ...categories]);
            })
            .catch(err => { });
    };

    const clickCategory = (categoryName, event) => {
        console.log('clickCategory('+categoryName+'`, '+event+')');
        navigate("/search/" + categoryName);
        console.log('event', event);
        console.log('event.stopPropagation = '+event.stopPropagation);
        event.stopPropagation();
        return false;
    };

    const getCategoryName = (categoryId) => {
        console.log('getCategoryName('+categoryId+')');
        /*
        let categoryId = categoryFilterObj?.filter(
            item => item.name === categoryFilter
        )[0]?.id;
        */
        return categoryFilterObj?.filter(
            item => item.id === categoryId
        )[0]?.name;
    };

    //let categoryName;

    return (

        <section
            //className = { "dark" }
            //className = "sensei sensei-dark"
            className = "sensei sensei-white full-width"
            style = {{
                //backgroundColor: "white"
                //, backgroundImage: 'none'
                //, backgroundImage: 'url(/images/backgrounds/city-sky.jpg)'
                paddingBottom: '0px' // overwrite padding-bottom
            }}
            >
            
            <div
                //id = 'latest-arrivals-wrapper'
                //className = { "max-width" }
                //style = {{ overflow: 'hidden' }}
                >

                <div
                    //className = 'table'
                    //className = 'flex-box section-header'
                    className = 'flex-box section-header max-width'
                    //style = {{
                        //margin: 'auto'
                        //, justifyContent: 'center'
                    //}}
                    >

                    {/*
                    <div className = 'row'>
                    */}
                        <div
                            //className = 'cell'
                            className = 'flex-item section-header-left'
                            //style = {{
                                //verticalAlign: 'middle'
                                //, width: '120px'
                                //, textAlign: 'left'
                                //, marginLeft: 'auto'
                                //, marginRight: 'auto'
                            //}}
                            >
                            <img
                                className = 'realsplit-logo'
                                src = 'images/Sensei-Labs/RealSplit-New-Logo-Building-Only_512x512.png'
                                style = {{
                                    //maxHeight: '60px'
                                    //, verticalAlign: 'middle'
                                    //, maxWidth: '50px'
                                }}
                                />
                        </div>

                        <div
                            //className = 'cell'
                            className = 'flex-item'
                            //style = {{
                            //    padding: '0px 50px'
                            //}}
                            >
                            <h2
                                //className = { styles.sectionTitle }
                                //style = {{ color: '#000' }}
                                style = {{
                                    whiteSpace: 'nowrap'
                                    //, paddingTop: '50px'
                                    //, paddingBottom: '50px'
                                }}
                                >Past Deals</h2>
                        </div>

                        <div
                            //className = 'cell'
                            className = 'flex-item section-header-right'
                            //style = {{
                                //verticalAlign: 'middle'
                                //, width: '120px'
                                //, textAlign: 'right'
                                //, marginLeft: 'auto'
                                //, marginRight: 'auto'
                            //}}
                            >
                            <img
                                className = 'realsplit-logo'
                                src = 'images/Sensei-Labs/RealSplit-New-Logo-Building-Only_512x512.png'
                                //style = {{
                                //    maxHeight: '60px'
                                    //, maxWidth: '50px'
                                //}}
                                />
                        </div>
                    {/*
                    </div>
                    */}
                </div>
                

                {/*
                <div className = { cn("container", "card-container") } style = {{ gap: "10px", justifyContent: "spaceBetween" }}>
                */}
                <div
                    //id = 'latest-arrivals-container'
                    className = {
                        'container'
                        //'container latest-arrivals-container'
                        , 'search-results'
                    }
                    style={{
                        gap: "10px"
                        //, justifyContent: "spaceBetween"
                        , justifyContent: "space-between"
                        , padding: 0
                        //, width: '1244px'
                        //, width: '1024px'
                        //, overflow: 'hidden'
                        , marginBottom: '100px'
                    }}>
                    {
                        data.length ?
                        <>

                            {/*<div className = 'search-results'>*/}

                                <div
                                    className = 'assets-container assets-container-single'
                                    style = {{
                                        /*
                                        display: 'flex'
                                        , flexWrap: 'wrap'
                                        , gap: '30px'
                                        , justifyContent: 'space-evenly'
                                        , alignItems: 'flex-start'
                                        , alignContent: 'stretch'
                                        , placeContent: 'stretch space-evenly'
                                        , alignItems: 'stretch'
                                        , alignContent: 'stretch'
                                        */
                                        padding: '0px 150px'
                                        , backgroundColor: 'unset'
                                    }}
                                    >

                                    {
                                        data.map((assetObject, index) => {
                                            //{ categoryName = getCategoryName(assetObject?.asset.categoryId) }
                                            if (!assetObject?.asset) return;

                                            { categoryName = getCategoryName(assetObject?.asset.categoryId) }

                                            // For debugging
                                            //console.debug('PastDealsCustomized (JSX): categoryName = ', categoryName);
                                            //console.debug('PastDealsCustomized (JSX): assetObject?.asset.status = ', assetObject?.asset.status);
                                            //console.debug('PastDealsCustomized (JSX): assetObject?.saleType = ', assetObject?.saleType);
                                            //console.debug('PastDealsCustomized (JSX): assetObject?.status = ', assetObject?.status);
                                            
                                            //const upcomingAsset = assetObject?.auction ? checkForUpcomingBid(assetObject?.auction?.startDate) : false;
                                            return (
                                                <PastDealsAssetCard
                                                //<AssetCard
                                                    index = { index }
                                                    assetObject = { assetObject }
                                                    categoryName = { categoryName }
                                                    clickCategory = { clickCategory }
                                                    />
                                            )
                                        })
                                    }
                                </div>
                            {/*</div>*/}
                        </>
                        : <div className={styles.nodata}>
                            No Past Deals
                        </div>
                    }
                </div>

            </div>
        </section>

    );
};

export default PastDealsCustomized;
